<div>
  <h1>Authorization Error</h1>
  <p *ngFor="let error of errors">{{error}}</p>
  <a a-button class="btn_primary" [routerLink]="AppUrls.getLogout()">Try again</a>
</div>
